module.exports = __webpack_public_path__ + "media/images/proof_links/myspace-596b8f182bfbd7a535e7e14acaebee8b.svg";